import { useResultStore } from "@func-core/core/data/repositories/result-repository";
import {
  PetParentData,
  ResultViewModel,
} from "@func-core/core/domain/view-models/result-view-model";

type UseResultReturn = {
  result: ResultViewModel | null;
  setResult: (result: ResultViewModel) => void;
  clearResult: () => void;
  updatePetParentData: (resultUuid: string, data: Partial<PetParentData>) => void;
};

export function useResult(): UseResultReturn {
  const result = useResultStore.use.result();
  const setResult = useResultStore.use.setResult();
  const clearResult = useResultStore.use.clearResult();
  const updatePetParentData = useResultStore.use.updatePetParentData();

  return {
    result,
    setResult,
    clearResult,
    updatePetParentData,
  };
}
